<script setup>
import MultiSelectComponent from "@/components/MultiSelectComponent.vue";
import { useStore } from "vuex";
import { computed, onMounted, ref, watch } from "vue";
import DatePicker from "./DatePicker.vue";

const store = useStore();

const actionTypes = computed(() => {
  return store.getters["actionLogs/getActionTypes"];
});

const loading = computed(() => store.getters["courses/isLoading"]);

const courses = computed(() => store.getters["courses/getCourseNames"]);

const coursesSelected = ref([]);

const actionType = ref("");

watch(coursesSelected, (newValue) => {
  if (newValue.length > 0) {
    store.dispatch("actionLogs/setFilters", {
      course_names: newValue.map((course) => course.name),
    });
  } else {
    store.dispatch("actionLogs/setFilters", { course_names: [] });
  }
});

watch(actionType, (newValue) => {
  store.dispatch("actionLogs/setFilters", { action: newValue });
});

const filterLogs = () => {
  store.dispatch("actionLogs/fetchActionLogs");
};

onMounted(() => {
  store.dispatch("courses/fetchCourseNames");
});
</script>

<template>
  <div class="col-6 filter-column">
    <div class="card">
      <div v-if="loading" class="loading-spinner">
        <i class="fas fa-spinner fa-spin"></i>
      </div>
      <form>
        <div class="card-header">
          <h3 class="card-title">FILTERS OPTIONS:</h3>
        </div>
        <div class="card-body">
          <div class="card" style="padding: 20px">
            <div class="row">
              <div class="col-lg-12">
                <div class="form-group">
                  <label>Course Name</label>
                  <MultiSelectComponent
                    v-model="coursesSelected"
                    :options="courses"
                    label="name"
                    track-by="id"
                    placeholder="Select Courses"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12">
                <div class="form-group">
                  <label>Action Type</label>
                  <select class="form-control" v-model="actionType">
                    <option value="">Select Type</option>
                    <option
                      v-for="type in actionTypes"
                      :key="type.value"
                      :value="type.value"
                    >
                      {{ type.title }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row">
              <DatePicker />
            </div>

            <div class="row">
              <div class="col-lg-12">
                <div class="form-group">
                  <button
                    type="button"
                    class="btn btn-block btn-success"
                    @click="filterLogs()"
                    :disabled="loading"
                  >
                    <font-awesome-icon
                      v-show="loading"
                      :icon="['fas', 'spinner']"
                      spin
                    />
                    <span v-show="!loading">Filter Logs</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<style scoped>
.loading-spinner {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  z-index: 10;
  background: #000000;
  opacity: 0.4;
  font-size: 40px;
}

@media (max-width: 1024px) {
  .filter-column {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
</style>
